export { default as InsurancePeriodPicker } from '@/modules/commons/components/MonthPeriodPicker';

/** Derive API month (1-12) and year from period picker value. */
export function monthYearFromPeriod(period: Date | null | undefined): { month: number; year: number } {
  const date = period && !Number.isNaN(period.getTime()) ? period : new Date();
  return {
    month: date.getMonth() + 1,
    year: date.getFullYear(),
  };
}
